import type { ResponseDto } from '@app/api/dtos'
import type { TranslationsConfigDataSource } from '@app/types/dataSource'
import type {
  TranslationsConfigClustersDataSource,
  TranslationsConfigCompetitorsDataSource,
  TranslationsConfigMonitoringTypesDataSource
} from '@app/types/dataSource/TranslationsConfigDataSource'
import type {
  TranslationsConfigClusterDto,
  TranslationsConfigCompetitorsDto,
  TranslationsConfigDto,
  TranslationsConfigMonitoringTypeDto
} from '@app/api/routes/translationsConfig/dtos'

export const getTranslationsConfigDataFromResponse = (
  response?: TranslationsConfigDto
): TranslationsConfigDataSource | undefined => {
  if (!response) return

  return {
    historicalDepthPerDays: response?.historicalDepthPerDays ?? null,
    startAtDayOfWeek: response?.startAtDayOfWeek ?? null,
    startAtTime: response?.startAtTime ?? null
  }
}

export const getTranslationsConfigCompetitorsDataFromResponse = (
  response?: ResponseDto<TranslationsConfigCompetitorsDto>
): TranslationsConfigCompetitorsDataSource[] | undefined => {
  if (!response) return

  const rawData: TranslationsConfigCompetitorsDto[] | undefined = response?.results

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id,
    network: dto?.network?.name ?? null,
    text: dto?.text ?? null,
    salesOrganization: dto?.salesOrganizatiion?.name ?? null,
    clustersGroup: dto?.clusterGroup?.name ?? null,
    cluster: dto?.cluster?.name ?? null
  }))
}

export const getTranslationsConfigMonitoringTypesDataFromResponse = (
  response?: ResponseDto<TranslationsConfigMonitoringTypeDto>
): TranslationsConfigMonitoringTypesDataSource[] | undefined => {
  if (!response) return

  const rawData: TranslationsConfigMonitoringTypeDto[] | undefined = response?.results

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id,
    name: dto.name
  }))
}

export const getTranslationsConfigClustersDataFromResponse = (
  response?: ResponseDto<TranslationsConfigClusterDto>
): TranslationsConfigClustersDataSource[] | undefined => {
  if (!response) return

  const rawData: TranslationsConfigClusterDto[] | undefined = response?.results

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id,
    fromClusters: dto.fromCluster.name,
    toClusters: dto.toCluster.name
  }))
}
